import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import RemoveIcon from '@mui/icons-material/Remove';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';

const PREFIX = 'PasswordConstraintChecker';

const classes = {
  container: `${PREFIX}-container`,
  row: `${PREFIX}-row`,
  icon: `${PREFIX}-icon`,
  logo1: `${PREFIX}-logo1`,
  logo2: `${PREFIX}-logo2`,
  content: `${PREFIX}-content`,
  input: `${PREFIX}-input`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#F8F9FC',
    padding: theme.spacing(2),
  },

  [`& .${classes.row}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.icon}`]: {
    marginRight: theme.spacing(1),
    fontSize: 14,
  },
}));

interface RequiermentRowProps {
  label: string;
  valid: boolean;
}

function RequirementRow({ label, valid }: RequiermentRowProps) {
  return (
    <Box className={classes.row}>
      {!valid && <RemoveIcon className={classes.icon} />}
      {valid && <CheckIcon color="primary" className={classes.icon} />}
      <Typography variant="body2">{label}</Typography>
    </Box>
  );
}

interface PasswordContraintCheckerProps {
  minCharacters?: number;
  currentValue: string;
}

export default function PasswordContraintChecker({
  minCharacters = 8,
  currentValue,
}: PasswordContraintCheckerProps) {
  const { t } = useTranslation('common');

  return (
    <Root className={classes.container}>
      <Typography variant="body1">{t('auth.requirements')}</Typography>
      <RequirementRow
        label={t('auth.lower')}
        valid={/[a-z]/g.test(currentValue)}
      />
      <RequirementRow
        label={t('auth.upper')}
        valid={/[A-Z]/g.test(currentValue)}
      />
      <RequirementRow
        label={t('auth.number')}
        valid={/\d/g.test(currentValue)}
      />
      <RequirementRow
        label={t('auth.specialCharater')}
        valid={/[^a-zA-Z0-9\s]/g.test(currentValue)}
      />
      <RequirementRow
        label={t('auth.minChars', { min: minCharacters })}
        valid={currentValue?.length >= minCharacters}
      />
    </Root>
  );
}
